import { NgModule } from '@angular/core';
import { ResolveRideMonitoringAlertDialogComponent } from './resolve-ride-monitoring-alert-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [ResolveRideMonitoringAlertDialogComponent],
  imports: [MatButtonModule, MatCheckboxModule, MatDialogModule, MatIconModule, MatInputModule, ReactiveFormsModule],
  exports: [ResolveRideMonitoringAlertDialogComponent]
})
export class ResolveRideMonitoringAlertDialogModule {}
